export default "__VITE_ASSET__66124082__"